import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "@src/api/config";
import { o360Coverage } from "@src/components/certs/o360/memberships/o360.types";

type O360CoveragesState = {
  coverages: o360Coverage[];
  loading: boolean;
};

export const getO360Skus = createAsyncThunk<
  { data: any },
  { client_id?: number | string | null }
>("o360/coverages", async ({ client_id } = {}, { getState }) => {
  const state = getState() as {
    products?: { productSelected?: { value?: string | number } };
    businessLines?: { businessLineSelected?: { id?: string | number } };
  };
  const product = state.products?.productSelected?.value ?? "";
  const business_line = state.businessLines?.businessLineSelected?.id ?? "";
  const params: Record<string, any> = { product, business_line, show_in_package: true };
  if (client_id !== null) params.client_id = client_id;
  const response = await api.get("/api/skus", { params });
  return { data: response.data };
});

/**
 * @description Get all SKUs (unpaginated) of a product/business line as select options
 */
export const getSkuOptions = async (
  product: number | string,
  business_line: number | string,
  signal?: AbortSignal
): Promise<{ value: number; label: string }[]> => {
  const { data } = await api.get("/api/skus", {
    params: { format: "options", product, business_line },
    signal
  });
  return Array.isArray(data) ? data : [];
};

const normalizeCoverages = (payload: any): o360Coverage[] => {
  if (Array.isArray(payload?.data?.data)) {
    return payload.data.data;
  }
  if (Array.isArray(payload?.data)) {
    return payload.data;
  }
  if (Array.isArray(payload)) {
    return payload;
  }
  return [];
};

const initialState: O360CoveragesState = {
  coverages: [],
  loading: false
};

const o360CoveragesSlice = createSlice({
  name: "o360Coverages",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getO360Skus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getO360Skus.fulfilled, (state, action) => {
      state.coverages = normalizeCoverages(action.payload.data);
      state.loading = false;
    });
    builder.addCase(getO360Skus.rejected, (state) => {
      state.loading = false;
    });
  }
});

export default o360CoveragesSlice.reducer;
